import { jobIsAvailableRouteGuard } from '@apps/customer/routeGuards';
import type { RouteRecordRaw } from 'vue-router';

export const CHECKOUT = 'checkout';
export const ORDER_REVIEW = 'checkout-order-review';
export const ORDER_CONFIRMATION = 'checkout-order-confirmation';

const routes: RouteRecordRaw[] = [
  {
    path: ':jobId',
    children: [
      {
        path: 'checkout',
        children: [
          {
            name: CHECKOUT,
            path: '',
            component: () => import('./pages/CheckoutPage.vue'),
            beforeEnter: [jobIsAvailableRouteGuard],
          },
          {
            name: ORDER_REVIEW,
            path: 'review',
            component: () => import('./pages/OrderReviewPage.vue'),
            beforeEnter: [jobIsAvailableRouteGuard],
          },
        ],
      },
      {
        name: ORDER_CONFIRMATION,
        path: 'order/:orderNumber',
        component: () => import('./pages/OrderConfirmationPage.vue'),
      },
    ],
  },
];

export default routes;
